module.exports = {
	"pagination": {
		"DescribeConnections": {
			"result_key": "connections"
		},
		"DescribeConnectionsOnInterconnect": {
			"result_key": "connections"
		},
		"DescribeInterconnects": {
			"result_key": "interconnects"
		},
		"DescribeLocations": {
			"result_key": "locations"
		},
		"DescribeVirtualGateways": {
			"result_key": "virtualGateways"
		},
		"DescribeVirtualInterfaces": {
			"result_key": "virtualInterfaces"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/directconnect-2012-10-25.paginators.json
// module id = 1956
// module chunks = 0